import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { RequestService } from 'src/app/core/services/request.service';
import { IdCardSides } from 'src/app/shared/enums/id-card-sides.enum';

@Component({
  selector: 'app-id-card-image',
  templateUrl: './id-card-image.component.html',
  styleUrls: ['./id-card-image.component.scss']
})
export class IdCardImageComponent implements OnInit {

  @Input() side: IdCardSides;

  imageUrl: string;

  @Output()
  imagePath = new EventEmitter<any>();

  constructor(private requestService: RequestService) {

  }

  ngOnInit() {
    this.imageUrl = 'assets/img/' + this.side + '.png';
  }

  upload(event) {

    const file = event.target.files[0];
    const task = this.requestService.uploadFile(file);

    task.then(snapshot => snapshot.ref.getDownloadURL())
      .then(url => {
        this.imageUrl = url;
      });

    task.then(snapshot => snapshot.ref.fullPath)
      .then(url => {
        this.imagePath.emit({ side: this.side, url: url });
      });
  }
}
